<template>
  <div
    :class="{
      'search-bar': true,
      fixed: fixed,
      puppet: puppet
    }"
  >
    <div class="search-wrap">
      <div class="search-bar-contrainer">
        <div class="search-bar-input">
          <i class="yxl-font yxl-font-search"></i>
          <input
            ref="search-input"
            type="search"
            :placeholder="placeholder"
            @keyup.enter="enter"
            @change="change"
            v-model="inputValue"
          />
          <v-touch
            tag="i"
            class="yxl-font yxl-font-FM51delete2 clear-btn"
            v-show="!!inputValue"
            @tap="inputValue = ''"
          ></v-touch>
        </div>
      </div>

      <v-touch class="search-btn" @tap="enter" v-if="isShowButton">
        {{ btnText }}
      </v-touch>
    </div>
  </div>
</template>

<script>
export default {
  name: 'searchBar',
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    puppet: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请输入搜索内容'
    },
    defaultValue: {
      type: String,
      default: ''
    },
    isShowButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: ''
    }
  },

  computed: {
    btnText() {
      return this.inputValue ? '搜索' : '取消'
    }
  },
  methods: {
    enter() {
      if (!!this.inputValue) {
        this.$refs['search-input'].blur()
        this.$emit('enter', this.value)
      } else {
        this.$emit('cancel')
      }
    },
    change(e) {
      const { value } = e.target
      this.$emit('input', value)
    },
    focus() {
      this.$refs['search-input'].focus()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/sass/config';
@import '../assets/sass/function';
@import '../assets/sass/mixin';
.search-bar {
  height: pxToRem(140);
  &.puppet {
    .search-wrap {
      background: #fff;
    }
    .search-bar-contrainer {
      position: relative;

      &:after {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        content: '';
      }
    }
  }

  &.fixed {
    .search-wrap {
      height: pxToRem(140);
      position: fixed;
      background: #fff;
      left: 50%;
      box-sizing: border-box;
      width: pxToRem(750);
      margin-left: pxToRem(-750/2);
      z-index: 10;
      display: flex;
      padding: 0 pxToRem(30);
      align-items: center;
      .search-bar-contrainer {
        flex: 1;
      }
      .search-btn {
        width: pxToRem(98);
        height: pxToRem(60);
        line-height: pxToRem(60);
        background: #0b8bff;
        text-align: center;
        color: #fff;
        border-radius: 4px;
        margin-left: pxToRem(30);
      }
    }
  }
}

.search-bar-input {
  border-radius: pxToRem(40);
  background: #f3f4f5;
  display: flex;
  align-items: center;
  padding-left: pxToRem(36);
  height: pxToRem(80);
  input {
    flex: 1;
    background: none;
    line-height: pxToRem(80);
    @include font-dpr(14px);
    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button {
      display: none;
    }
  }
  .clear-btn {
    display: block;
    height: 100%;
    padding: 0 pxToRem(36);
  }
  .yxl-font-search {
    margin-right: pxToRem(20);
  }
  .yxl-font {
    color: #999;
    @include font-dpr(16px);
    line-height: pxToRem(80);
  }
}
</style>



// WEBPACK FOOTER //
// searchBar.vue?9e1dca92